import { useQuery } from '@tanstack/react-query'
import { getEditorialMe, type EditorialMe } from './api'

/** The writer level (operator decision 2026-10-04): the server says what this person may do; the UI
 *  hides the rest. Unknown (still loading, or the call failed) counts as "cannot publish", so a
 *  writer never sees a Publish button flash; the server refuses anyway. */
export function canPublish(me: Pick<EditorialMe, 'can_publish'> | null | undefined): boolean {
  return me?.can_publish === true
}

/** The tabs a writer does not get: Schedule, Social, Topic pages and Settings are editors' screens. */
export const EDITOR_TABS = new Set(['schedule', 'social', 'topics', 'settings', 'from-wordpress'])

export function tabsFor<T extends { to: string }>(tabs: T[], me: Pick<EditorialMe, 'can_publish'> | null | undefined): T[] {
  return canPublish(me) ? tabs : tabs.filter((t) => !EDITOR_TABS.has(t.to))
}

export function useEditorialMe() {
  return useQuery({ queryKey: ['editorial', 'me'], queryFn: getEditorialMe, staleTime: 60_000, retry: false })
}
